import { Box } from "@material-ui/core";
import { Link as ReactLink, useLocation } from "react-router-dom";
import { camelCaseToTitle } from "../../utils/camelCaseToTitle";

function SubMenu({ country, collections }) {
    const location = useLocation();

    return (
        <>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                className="edit-meta-data-sub-menu-container"
            >
                {collections
                    .filter(
                        (collection) =>
                            country === "OTHERS" ||
                            collection.countries.some((c) => c === country),
                    )
                    .map((collection) => {
                        return (
                            <ReactLink
                                color="inherit"
                                to={`/metadata/${country}/${collection.name}`}
                                className={
                                    location.pathname.includes(collection.name)
                                        ? "edit-meta-data-sub-menu active"
                                        : "edit-meta-data-sub-menu"
                                }
                            >
                                {camelCaseToTitle(collection.name)}
                            </ReactLink>
                        );
                    })}
            </Box>
        </>
    );
}

export default SubMenu;
